import { render, staticRenderFns } from "./Barvolumeresponse.vue?vue&type=template&id=26b7b8c0&"
import script from "./Barvolumeresponse.vue?vue&type=script&lang=js&"
export * from "./Barvolumeresponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports